import { defineComponent as _defineComponent } from 'vue'
import CategoryProductFacetFilteringGroup from './CategoryProductFacetFilteringGroup.vue';
import CategoryProductFacetFilteringDropdown from './CategoryProductFacetFilteringDropdown.vue';
import { groupBy } from 'lodash';
import { Dictionary } from 'vuex';
import { computed, nextTick, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryProductFacetFiltering',
  props: {
    availableFacets: null,
    visibleFacets: null,
    useFacetGroups: { type: Boolean }
  },
  emits: ["update-height"],
  setup(__props: any, { emit }: { emit: ({(e: 'update-height'): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    availableFacets?: { [facetId: string] : FacetValueViewObject[] },
    visibleFacets: FacetViewObject[],
    useFacetGroups: boolean
}




const showMoreFacets = ref<boolean>(false);

const facetsToShow = computed<FacetViewObject[]>(() => {
    if (props.useFacetGroups && !showMoreFacets.value) {
        return props.visibleFacets.slice(0, 4);
    }
    return props.visibleFacets;
});

const groupedFacets = computed<Dictionary<FacetViewObject[]>>(() => groupBy(props.visibleFacets, 'group'));
const facetGroupNames = computed<string[]>(() => Object.keys(groupedFacets.value).sort());

async function showMore() {
    showMoreFacets.value = true;
    await nextTick();
    emit('update-height');
}


return { __sfc: true,props, emit, showMoreFacets, facetsToShow, groupedFacets, facetGroupNames, showMore, CategoryProductFacetFilteringGroup, CategoryProductFacetFilteringDropdown }
}

})